<template>
  <div class="login-container" :style="{ 'background-image': 'url(' + images.background + ')' }">
    <div class="login-content">
      <div class="login-top">
        <div class="login-header">
          <img alt="logo" class="logo" :src="images.logonobox">
          <span class="logo-title">PT. LESTARI JAYA RAYA SENTOSA</span>
        </div>
        <div class="login-desc">Customer Web Tracking Application Login</div>
      </div>
      <div class="login">
        <div v-if="loggingIn" class="container-loading">
          <a-spin :indicator="indicator"/>
        </div>
        <p v-if="loginError">
          <a-alert
            message="Login Failed"
            :description="loginError"
            type="warning"
            showIcon
            closable
          />
        </p>
        <p v-if="loginSuccessful">
          <a-alert message="Login Successful" type="success" showIcon closable/>
        </p>
        <LoginForm @submited="loginSubmit"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoginForm from "@/components/forms/LoginForm.vue";

export default {
  components: {
    LoginForm
  },
  data() {
    return {
      indicator: (
        <i
          class="anticon anticon-loading anticon-spin ant-spin-dot"
          style="font-size: 24px;"
        />
      ),
      images: {
        background: require("@/assets/background.jpg"),
        logonobox: require("@/assets/logo ljrs.png")
      }
    };
  },
  computed: {
    ...mapState("auth", {
      loggingIn: state => state.loggingIn,
      loginError: state => state.loginError,
      loginSuccessful: state => state.loginSuccessful
    })
  },
  methods: {
    ...mapActions("auth", ["doLogin"]),
    loginSubmit(formData) {
      this.doLogin({
        username: formData.username,
        password: formData.password,
        remember_me: formData.remember_me
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-color: #063561;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: 110px;
  flex-direction: column;
  display: flex;
  overflow: auto;
}

.login-container .login-content .login-top .login-header .logo {
  height: 55px;
  vertical-align: top;
  margin-right: 16px;
}

.login-content {
  padding: 112px 0 24px;
}

.login {
  width: 300px;
  margin: 0 auto;
}

.login-top {
  text-align: center;
}

.login-header {
  height: 40px;
  line-height: 40px;
}

.login-desc {
  font-size: 1em;
  margin-top: 12px;
  margin-bottom: 40px;
  color: #c4cfd6;
}

.logo-title {
  font-size: 1.8em;
  color: #c4cfd6;
}
</style>